/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NftLevelUpInfoData from './NftLevelUpInfoData';

/**
 * The NftProperty model module.
 * @module model/NftProperty
 * @version 1.0
 */
class NftProperty {
    /**
     * Constructs a new <code>NftProperty</code>.
     * @alias module:model/NftProperty
     */
    constructor() { 
        
        NftProperty.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftProperty</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftProperty} obj Optional instance to populate.
     * @return {module:model/NftProperty} The populated <code>NftProperty</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftProperty();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftKey')) {
                obj['nftKey'] = ApiClient.convertToType(data['nftKey'], 'String');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = ApiClient.convertToType(data['nftType'], 'Number');
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = ApiClient.convertToType(data['nftGrade'], 'Number');
            }
            if (data.hasOwnProperty('baseSpeed')) {
                obj['baseSpeed'] = ApiClient.convertToType(data['baseSpeed'], 'Number');
            }
            if (data.hasOwnProperty('baseLuck')) {
                obj['baseLuck'] = ApiClient.convertToType(data['baseLuck'], 'Number');
            }
            if (data.hasOwnProperty('baseEnergy')) {
                obj['baseEnergy'] = ApiClient.convertToType(data['baseEnergy'], 'Number');
            }
            if (data.hasOwnProperty('baseDurability')) {
                obj['baseDurability'] = ApiClient.convertToType(data['baseDurability'], 'Number');
            }
            if (data.hasOwnProperty('sigil')) {
                obj['sigil'] = ApiClient.convertToType(data['sigil'], 'String');
            }
            if (data.hasOwnProperty('gemSocketColors')) {
                obj['gemSocketColors'] = ApiClient.convertToType(data['gemSocketColors'], 'String');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('imageUrl')) {
                obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
            }
            if (data.hasOwnProperty('minted')) {
                obj['minted'] = ApiClient.convertToType(data['minted'], 'Boolean');
            }
            if (data.hasOwnProperty('imageKey')) {
                obj['imageKey'] = ApiClient.convertToType(data['imageKey'], 'String');
            }
            if (data.hasOwnProperty('revealed')) {
                obj['revealed'] = ApiClient.convertToType(data['revealed'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('revealedAt')) {
                obj['revealedAt'] = ApiClient.convertToType(data['revealedAt'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'Number');
            }
            if (data.hasOwnProperty('boxRarity')) {
                obj['boxRarity'] = ApiClient.convertToType(data['boxRarity'], 'Number');
            }
            if (data.hasOwnProperty('boxBlessedFlag')) {
                obj['boxBlessedFlag'] = ApiClient.convertToType(data['boxBlessedFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('boxImageUrl')) {
                obj['boxImageUrl'] = ApiClient.convertToType(data['boxImageUrl'], 'String');
            }
            if (data.hasOwnProperty('lparentNftUid')) {
                obj['lparentNftUid'] = ApiClient.convertToType(data['lparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('rparentNftUid')) {
                obj['rparentNftUid'] = ApiClient.convertToType(data['rparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('metadataUrl')) {
                obj['metadataUrl'] = ApiClient.convertToType(data['metadataUrl'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('burnedAt')) {
                obj['burnedAt'] = ApiClient.convertToType(data['burnedAt'], 'Date');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('extraStatsPoint')) {
                obj['extraStatsPoint'] = ApiClient.convertToType(data['extraStatsPoint'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsSpeed')) {
                obj['extraStatsSpeed'] = ApiClient.convertToType(data['extraStatsSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsLucky')) {
                obj['extraStatsLucky'] = ApiClient.convertToType(data['extraStatsLucky'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsEnergy')) {
                obj['extraStatsEnergy'] = ApiClient.convertToType(data['extraStatsEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsDurability')) {
                obj['extraStatsDurability'] = ApiClient.convertToType(data['extraStatsDurability'], 'Number');
            }
            if (data.hasOwnProperty('extraSpeed')) {
                obj['extraSpeed'] = ApiClient.convertToType(data['extraSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraLuck')) {
                obj['extraLuck'] = ApiClient.convertToType(data['extraLuck'], 'Number');
            }
            if (data.hasOwnProperty('extraEnergy')) {
                obj['extraEnergy'] = ApiClient.convertToType(data['extraEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraDurability')) {
                obj['extraDurability'] = ApiClient.convertToType(data['extraDurability'], 'Number');
            }
            if (data.hasOwnProperty('condition')) {
                obj['condition'] = ApiClient.convertToType(data['condition'], 'Number');
            }
            if (data.hasOwnProperty('mileage')) {
                obj['mileage'] = ApiClient.convertToType(data['mileage'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('mintingCount')) {
                obj['mintingCount'] = ApiClient.convertToType(data['mintingCount'], 'Number');
            }
            if (data.hasOwnProperty('genesisMintingCount')) {
                obj['genesisMintingCount'] = ApiClient.convertToType(data['genesisMintingCount'], 'Number');
            }
            if (data.hasOwnProperty('gemSockets')) {
                obj['gemSockets'] = ApiClient.convertToType(data['gemSockets'], 'String');
            }
            if (data.hasOwnProperty('engineSocket')) {
                obj['engineSocket'] = ApiClient.convertToType(data['engineSocket'], 'Number');
            }
            if (data.hasOwnProperty('updateAt')) {
                obj['updateAt'] = ApiClient.convertToType(data['updateAt'], 'Date');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('expiredAt')) {
                obj['expiredAt'] = ApiClient.convertToType(data['expiredAt'], 'Date');
            }
            if (data.hasOwnProperty('nftLevelUpInfo')) {
                obj['nftLevelUpInfo'] = NftLevelUpInfoData.constructFromObject(data['nftLevelUpInfo']);
            }
            if (data.hasOwnProperty('storedPower')) {
                obj['storedPower'] = ApiClient.convertToType(data['storedPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPower')) {
                obj['addedMaxStoredPower'] = ApiClient.convertToType(data['addedMaxStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPowerEndAt')) {
                obj['addedMaxStoredPowerEndAt'] = ApiClient.convertToType(data['addedMaxStoredPowerEndAt'], 'Date');
            }
            if (data.hasOwnProperty('speed')) {
                obj['speed'] = ApiClient.convertToType(data['speed'], 'Number');
            }
            if (data.hasOwnProperty('luck')) {
                obj['luck'] = ApiClient.convertToType(data['luck'], 'Number');
            }
            if (data.hasOwnProperty('energy')) {
                obj['energy'] = ApiClient.convertToType(data['energy'], 'Number');
            }
            if (data.hasOwnProperty('durability')) {
                obj['durability'] = ApiClient.convertToType(data['durability'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftProperty</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftProperty</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftKey'] && !(typeof data['nftKey'] === 'string' || data['nftKey'] instanceof String)) {
            throw new Error("Expected the field `nftKey` to be a primitive type in the JSON string but got " + data['nftKey']);
        }
        // ensure the json data is a string
        if (data['sigil'] && !(typeof data['sigil'] === 'string' || data['sigil'] instanceof String)) {
            throw new Error("Expected the field `sigil` to be a primitive type in the JSON string but got " + data['sigil']);
        }
        // ensure the json data is a string
        if (data['gemSocketColors'] && !(typeof data['gemSocketColors'] === 'string' || data['gemSocketColors'] instanceof String)) {
            throw new Error("Expected the field `gemSocketColors` to be a primitive type in the JSON string but got " + data['gemSocketColors']);
        }
        // ensure the json data is a string
        if (data['imageUrl'] && !(typeof data['imageUrl'] === 'string' || data['imageUrl'] instanceof String)) {
            throw new Error("Expected the field `imageUrl` to be a primitive type in the JSON string but got " + data['imageUrl']);
        }
        // ensure the json data is a string
        if (data['imageKey'] && !(typeof data['imageKey'] === 'string' || data['imageKey'] instanceof String)) {
            throw new Error("Expected the field `imageKey` to be a primitive type in the JSON string but got " + data['imageKey']);
        }
        // ensure the json data is a string
        if (data['boxImageUrl'] && !(typeof data['boxImageUrl'] === 'string' || data['boxImageUrl'] instanceof String)) {
            throw new Error("Expected the field `boxImageUrl` to be a primitive type in the JSON string but got " + data['boxImageUrl']);
        }
        // ensure the json data is a string
        if (data['metadataUrl'] && !(typeof data['metadataUrl'] === 'string' || data['metadataUrl'] instanceof String)) {
            throw new Error("Expected the field `metadataUrl` to be a primitive type in the JSON string but got " + data['metadataUrl']);
        }
        // ensure the json data is a string
        if (data['gemSockets'] && !(typeof data['gemSockets'] === 'string' || data['gemSockets'] instanceof String)) {
            throw new Error("Expected the field `gemSockets` to be a primitive type in the JSON string but got " + data['gemSockets']);
        }
        // validate the optional field `nftLevelUpInfo`
        if (data['nftLevelUpInfo']) { // data not null
          NftLevelUpInfoData.validateJSON(data['nftLevelUpInfo']);
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
NftProperty.prototype['nftUid'] = undefined;

/**
 * @member {String} nftKey
 */
NftProperty.prototype['nftKey'] = undefined;

/**
 * @member {Number} nftType
 */
NftProperty.prototype['nftType'] = undefined;

/**
 * @member {Number} nftGrade
 */
NftProperty.prototype['nftGrade'] = undefined;

/**
 * @member {Number} baseSpeed
 */
NftProperty.prototype['baseSpeed'] = undefined;

/**
 * @member {Number} baseLuck
 */
NftProperty.prototype['baseLuck'] = undefined;

/**
 * @member {Number} baseEnergy
 */
NftProperty.prototype['baseEnergy'] = undefined;

/**
 * @member {Number} baseDurability
 */
NftProperty.prototype['baseDurability'] = undefined;

/**
 * @member {String} sigil
 */
NftProperty.prototype['sigil'] = undefined;

/**
 * @member {String} gemSocketColors
 */
NftProperty.prototype['gemSocketColors'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
NftProperty.prototype['plusFlag'] = undefined;

/**
 * @member {String} imageUrl
 */
NftProperty.prototype['imageUrl'] = undefined;

/**
 * @member {Boolean} minted
 */
NftProperty.prototype['minted'] = undefined;

/**
 * @member {String} imageKey
 */
NftProperty.prototype['imageKey'] = undefined;

/**
 * @member {Boolean} revealed
 */
NftProperty.prototype['revealed'] = undefined;

/**
 * @member {Date} revealableAt
 */
NftProperty.prototype['revealableAt'] = undefined;

/**
 * @member {Date} revealedAt
 */
NftProperty.prototype['revealedAt'] = undefined;

/**
 * @member {Number} boxType
 */
NftProperty.prototype['boxType'] = undefined;

/**
 * @member {Number} boxRarity
 */
NftProperty.prototype['boxRarity'] = undefined;

/**
 * @member {Boolean} boxBlessedFlag
 */
NftProperty.prototype['boxBlessedFlag'] = undefined;

/**
 * @member {String} boxImageUrl
 */
NftProperty.prototype['boxImageUrl'] = undefined;

/**
 * @member {Number} lparentNftUid
 */
NftProperty.prototype['lparentNftUid'] = undefined;

/**
 * @member {Number} rparentNftUid
 */
NftProperty.prototype['rparentNftUid'] = undefined;

/**
 * @member {String} metadataUrl
 */
NftProperty.prototype['metadataUrl'] = undefined;

/**
 * @member {Date} createdAt
 */
NftProperty.prototype['createdAt'] = undefined;

/**
 * @member {Date} burnedAt
 */
NftProperty.prototype['burnedAt'] = undefined;

/**
 * @member {Boolean} valid
 */
NftProperty.prototype['valid'] = undefined;

/**
 * @member {Number} extraStatsPoint
 */
NftProperty.prototype['extraStatsPoint'] = undefined;

/**
 * @member {Number} extraStatsSpeed
 */
NftProperty.prototype['extraStatsSpeed'] = undefined;

/**
 * @member {Number} extraStatsLucky
 */
NftProperty.prototype['extraStatsLucky'] = undefined;

/**
 * @member {Number} extraStatsEnergy
 */
NftProperty.prototype['extraStatsEnergy'] = undefined;

/**
 * @member {Number} extraStatsDurability
 */
NftProperty.prototype['extraStatsDurability'] = undefined;

/**
 * @member {Number} extraSpeed
 */
NftProperty.prototype['extraSpeed'] = undefined;

/**
 * @member {Number} extraLuck
 */
NftProperty.prototype['extraLuck'] = undefined;

/**
 * @member {Number} extraEnergy
 */
NftProperty.prototype['extraEnergy'] = undefined;

/**
 * @member {Number} extraDurability
 */
NftProperty.prototype['extraDurability'] = undefined;

/**
 * @member {Number} condition
 */
NftProperty.prototype['condition'] = undefined;

/**
 * @member {Number} mileage
 */
NftProperty.prototype['mileage'] = undefined;

/**
 * @member {Number} level
 */
NftProperty.prototype['level'] = undefined;

/**
 * @member {Number} mintingCount
 */
NftProperty.prototype['mintingCount'] = undefined;

/**
 * @member {Number} genesisMintingCount
 */
NftProperty.prototype['genesisMintingCount'] = undefined;

/**
 * @member {String} gemSockets
 */
NftProperty.prototype['gemSockets'] = undefined;

/**
 * @member {Number} engineSocket
 */
NftProperty.prototype['engineSocket'] = undefined;

/**
 * @member {Date} updateAt
 */
NftProperty.prototype['updateAt'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
NftProperty.prototype['lastImportedAt'] = undefined;

/**
 * @member {Date} expiredAt
 */
NftProperty.prototype['expiredAt'] = undefined;

/**
 * @member {module:model/NftLevelUpInfoData} nftLevelUpInfo
 */
NftProperty.prototype['nftLevelUpInfo'] = undefined;

/**
 * @member {Number} storedPower
 */
NftProperty.prototype['storedPower'] = undefined;

/**
 * @member {Number} addedMaxStoredPower
 */
NftProperty.prototype['addedMaxStoredPower'] = undefined;

/**
 * @member {Date} addedMaxStoredPowerEndAt
 */
NftProperty.prototype['addedMaxStoredPowerEndAt'] = undefined;

/**
 * @member {Number} speed
 */
NftProperty.prototype['speed'] = undefined;

/**
 * @member {Number} luck
 */
NftProperty.prototype['luck'] = undefined;

/**
 * @member {Number} energy
 */
NftProperty.prototype['energy'] = undefined;

/**
 * @member {Number} durability
 */
NftProperty.prototype['durability'] = undefined;






export default NftProperty;

